import { DataTable } from "./DataTable";
import { labelize } from "../utils/format";
import { Spinner } from "./Loader";

function FormFields({ form, setForm, visibleFields, firstRowFields, selectFields, fieldLabels, requiredFields, readonlyFields, numberFields, dateFields, passwordFields, telFields, sanitizeFields, minDateFields, onFieldChange, currencyFields, colorFields, bgColorFields }) {
  return (
    <div className="card">
      {firstRowFields.length > 0 && (
        <div className="field-grid cols-3">
          {firstRowFields.map(
            (key) =>
              visibleFields.includes(key) && (
                <div className="field" key={key}>
                  <label>
                    {fieldLabels[key] || labelize(key)}{requiredFields.includes(key) && <span className="required-mark"> *</span>}
                    {selectFields[key] ? (
                      <select
                        required={requiredFields.includes(key)}
                        value={form[key] || ""}
                        disabled={readonlyFields.includes(key)}
                        onChange={(e) => {
                          setForm({ ...form, [key]: e.target.value });
                          if (onFieldChange) onFieldChange(key, e.target.value);
                        }}
                      >
                        <option value="">Select {fieldLabels[key] || labelize(key).toLowerCase()}</option>
                      {selectFields[key].map((opt) => (
                        <option key={opt.value || opt} value={opt.value || opt}>
                          {opt.label != null && String(opt.label) !== "" ? String(opt.label) : String(opt.value ?? opt)}
                        </option>
                      ))}
                      </select>
                    ) : (
                      <input
                        type={telFields.includes(key) ? "tel" : "text"}
                        inputMode={telFields.includes(key) ? "numeric" : undefined}
                        maxLength={telFields.includes(key) ? 10 : undefined}
                        required={requiredFields.includes(key)}
                        readOnly={readonlyFields.includes(key)}
                        placeholder={labelize(key)}
                        value={form[key] || ""}
                        onChange={(e) => {
                          let value = e.target.value;
                          if (sanitizeFields[key]) {
                            value = sanitizeFields[key](value);
                          }
                          setForm({ ...form, [key]: value });
                          if (onFieldChange) onFieldChange(key, value);
                        }}
                      />
                    )}
                  </label>
                </div>
              )
          )}
        </div>
      )}
      <div
        className="field-grid cols-3"
        style={{ marginTop: firstRowFields.length > 0 ? "16px" : undefined }}
      >
        {visibleFields.filter((f) => !firstRowFields.includes(f)).map((key) => (
          <div className="field" key={key}>
            <label>
              {fieldLabels[key] || labelize(key)}{requiredFields.includes(key) && <span className="required-mark"> *</span>}
              {selectFields[key] ? (
                <select
                  required={requiredFields.includes(key)}
                  value={form[key] || ""}
                  disabled={readonlyFields.includes(key)}
                  onChange={(e) => {
                    setForm({ ...form, [key]: e.target.value });
                    if (onFieldChange) onFieldChange(key, e.target.value);
                  }}
                >
                  <option value="">Select {fieldLabels[key] || labelize(key)}</option>
                  {selectFields[key].map((opt) => (
                    <option key={opt.value || opt} value={opt.value || opt}>
                      {opt.label || opt}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={telFields.includes(key) ? "tel" : numberFields.includes(key) ? "number" : dateFields.includes(key) ? "date" : passwordFields.includes(key) ? "password" : "text"}
                  inputMode={telFields.includes(key) ? "numeric" : undefined}
                  maxLength={telFields.includes(key) ? 10 : undefined}
                  required={requiredFields.includes(key)}
                  minLength={passwordFields.includes(key) ? 8 : undefined}
                  readOnly={readonlyFields.includes(key)}
                  min={minDateFields[key] ? (typeof minDateFields[key] === "function" ? minDateFields[key](form) : minDateFields[key]) : undefined}
                  placeholder={labelize(key)}
                  value={form[key] || ""}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (sanitizeFields[key]) {
                      value = sanitizeFields[key](value);
                    }
                    setForm({ ...form, [key]: value });
                    if (onFieldChange) onFieldChange(key, value);
                  }}
                />
              )}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

function FormActions({ saving, setForm, emptyForm, onClear, children }) {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
      <button
        type="button"
        className="secondary"
        disabled={saving}
        onClick={() => {
          setForm(emptyForm || Object.fromEntries(Object.keys(children).map((f) => [f, ""])));
        }}
      >
        Clear
      </button>
      {children}
    </div>
  );
}

export function CrudPanel({
  title,
  sectionLabel,
  header,
  rows,
  form,
  setForm,
  emptyForm,
  save,
  remove,
  onRestore,
  fields,
  firstRowFields = [],
  hideFormFields = [],
  hideTableFields = [],
  numberFields = [],
  dateFields = [],
  passwordFields = [],
  requiredFields = [],
  collapsible = false,
  showForm,
  setShowForm,
  buttonLabel,
  currencyFields = [],
  colorFields = {},
  bgColorFields = {},
  selectFields = {},
  formSelectFields = null,
  fieldLabels = {},
  columnLabels = {},
  onEdit,
  onFieldChange,
  onClear,
  extraContent,
  loading = false,
  saving = false,
  telFields = [],
  sanitizeFields = [],
  readonlyFields = [],
  minDateFields = {},
}) {
  const visibleFields = fields.filter((f) => !hideFormFields.includes(f));
  const tableFields = fields.filter((f) => !hideTableFields.includes(f));

  const renderForm = () => (
    <form onSubmit={save} aria-busy={saving || undefined}>
      {!collapsible && (
        <div className="card-header">
          <p className="section-label" style={{ margin: 0 }}>
            {sectionLabel || title}
          </p>
        </div>
      )}
<FormFields
        form={form}
        setForm={setForm}
        visibleFields={visibleFields}
        firstRowFields={firstRowFields}
        selectFields={formSelectFields || selectFields}
        fieldLabels={fieldLabels}
        requiredFields={requiredFields}
        readonlyFields={readonlyFields}
        numberFields={numberFields}
        dateFields={dateFields}
        passwordFields={passwordFields}
        telFields={telFields}
        sanitizeFields={sanitizeFields}
        minDateFields={minDateFields}
        onFieldChange={onFieldChange}
        currencyFields={currencyFields}
        colorFields={colorFields}
        bgColorFields={bgColorFields}
      />
      {extraContent && <div style={{ marginTop: "16px" }}>{extraContent}</div>}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
        {collapsible && (
          <button
            type="button"
            className="secondary"
            disabled={saving}
            onClick={() => {
              setForm(emptyForm || Object.fromEntries(fields.map((f) => [f, ""])));
              setShowForm(false);
              if (onClear) onClear();
            }}
          >
            Cancel
          </button>
        )}
        <button className="primary" type="submit" disabled={saving}>
          {saving && <Spinner size={14} />}
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </form>
  );

  if (collapsible) {
    return (
      <section className="stack">
        {showForm ? (
          renderForm()
        ) : (
          <DataTable
            rows={rows}
            fields={tableFields}
            header={header}
            onEdit={(row) => {
              setForm(row);
              setShowForm(true);
              if (onEdit) onEdit(row);
            }}
            onDelete={remove}
            onRestore={onRestore}
            currencyFields={currencyFields}
            colorFields={colorFields}
            bgColorFields={bgColorFields}
            loading={loading}
            selectFields={selectFields}
            columnLabels={columnLabels}
          />
        )}
      </section>
    );
  }

  return (
    <section className="stack">
      {renderForm()}
      <DataTable
        rows={rows}
        fields={tableFields}
        header={header}
        onEdit={(row) => {
          setForm(row);
          setShowForm(true);
          if (onEdit) onEdit(row);
        }}
        onDelete={remove}
        onRestore={onRestore}
        currencyFields={currencyFields}
        colorFields={colorFields}
        bgColorFields={bgColorFields}
        loading={loading}
        selectFields={selectFields}
        columnLabels={columnLabels}
      />
    </section>
  );
}